<template>
    <main class="w-full place-items-center md:bg-[#f3f3f3] min-h-full">
        <Head>
            <Title>U.P. Consultations &bull; ERROR.</Title>
            <Meta
                name="description"
                content="Ultimate Performance - Consultation booking service" />
            <meta
                name="robots"
                content="noindex" />
        </Head>
        <div
            class="container mx-auto py-6 md:py-12 lg:py-24 mainpage-padding-top md:max-w-[900px] flex min-h-screen border-box justify-center items-center">
            <div
                class="page page-enter-active page-leave-active w-full box-border p-4 md:px-6">
                <div
                    class="max-w-[900px] w-full flex flex-col text-center justify-center align-middle md:p-6 p-4 bg-white rounded-md">
                    <Icon
                        class="mb-6 !w-[56px] !h-[56px] block mx-auto"
                        icon="question-mark"
                        alt="U.P Location Icon" />
                    <ErrorCopy v-bind="page" />
                </div>
            </div>
        </div>
    </main>
</template>

<script setup>
    import { getErrorData } from '@/helpers/errorMessages';
    import { useBookingStore } from '@/stores/booking';
    import { useStateStore } from '@/stores/state';
    const { state: bookingState } = useBookingStore();
    const {
        getBusiness,
        getRequestId,
        getMode,
        isModeExisting,
        withNoEnquiry,
    } = useStateStore();

    const page = computed(() =>
        getErrorData(
            bookingState,
            withNoEnquiry(),
            isModeExisting(getMode()),
            getRequestId(),
            getBusiness()
        )
    );
</script>
